// extracted by mini-css-extract-plugin
export default {"searchInput":"style_searchInput__A18Yp"};